import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotesStore } from '../store';
import { Card, CardContent } from '../components/ui/card';
import { Clock, FileText } from 'lucide-react';

export default function RecentView() {
  const navigate = useNavigate();
  const { recentNotes, fetchRecent } = useNotesStore();

  useEffect(() => { fetchRecent(); }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-semibold flex items-center gap-2"><Clock size={20} /> Recent Notes</h1>
        <p className="text-sm text-muted-foreground">Recently accessed notes</p>
      </div>

      {recentNotes.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          <Clock size={48} className="mx-auto mb-4 opacity-50" />
          <p>No recent notes</p>
        </div>
      ) : (
        <div className="space-y-2">
          {recentNotes.map(note => (
            <Card key={note.id} className="hover:shadow-md transition-all cursor-pointer" onClick={() => navigate(`/note/${note.id}`)}>
              <CardContent className="flex items-center gap-3 p-4">
                <FileText size={16} className="text-muted-foreground" />
                <div className="flex-1">
                  <h3 className="font-medium">{note.title}</h3>
                  {note.content && <p className="text-sm text-muted-foreground line-clamp-1">{note.content.replace(/[#*`>\[\]]/g, '').slice(0, 100)}</p>}
                </div>
                <span className="text-xs text-muted-foreground">{new Date(note.updated_at).toLocaleDateString()}</span>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
